import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";

function GatewayLogsTable() {
  const [gatewayLogs, setGatewayLogs] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchGatewayLogs = async () => {
      setLoading(true)

      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/gateway_logs?page=${paginationModel.page + 1}&page_size=${paginationModel.pageSize}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch gateway logs");
        }
        const responseData = await response.json();
        // setGatewayLogs(responseData.results || []);
        console.log({ responseData });

        // let filtered = responseData.gateway_logs.filter((responsee)=> responsee.lat !== null && responsee.lon !== null)
        // console.log({filtered});
        setGatewayLogs(responseData.gateway_logs || []);

        setTotalRows(responseData.total || 0);
        setLoading(false)

      } catch (error) {
        console.error("Error fetching gateway logs:", error);
      }
    };

    fetchGatewayLogs();
  }, [paginationModel]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      headerAlign: "center",
      filterable: false,
      align: "center",
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "device_id",
      headerName: "Device ID",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "lat",
      headerName: "Latitude",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "lon",
      headerName: "Longitude",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "supply_voltage",
      headerName: "Supply Voltage",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "gsm_rssi",
      headerName: "GSM RSSI",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
  ];

  return (
    <div style={{ height: 400, width: "100%" }}>
      <DataGrid
        rows={gatewayLogs}
        columns={columns}
        density="compact"
        rowSelection={false}
        loading={loading}
        rowCount={totalRows}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        paginationMode="server"
        components={{
          Toolbar: GridToolbar,
          FilterPanel: GridFilterPanel,
        }}
        slotProps={{
          filterPanel: {
            sx: {
              width: "100%",          // full width responsive
              maxWidth: "100%",
              padding: "10px",
              "& .MuiDataGrid-filterForm": {
                flexDirection: "column",
                gap: "10px",
              },
            },
          },
        }}
      />
    </div>
  );
}

export default GatewayLogsTable;
